import callApi from './personnelService';

const basePath = `/frontend/api/one-to-one/${process.env.VUE_APP_COMPANY_KEY}/profile`;

export const saveAutoReply = (updateInfo) => callApi({
    method: 'PUT',
    endpoint: `${basePath}`,
    body: updateInfo
  });
